module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7HN6V"))).then(() => parcelRequire('iDabs'));